import React, { useMemo } from "react";
import clsx from "clsx";
import s from "~/pages/SRR/SRR.less";
import {
  ReportReturnLoyaltyServicePercentTable,
  ReportReturnLoyaltyServiceSalesTable,
  ReportReturnLoyaltyServiceUniqueVINTable,
} from "../Tables/ReportReturnLoyaltyServiceTable";
import Table from "~/components/Table";
import {
  getHeaders,
  nameColumnForPercentTable,
  nameColumnForSalesTable,
  nameColumnForUniqueVinTable,
  rowHelper,
} from "./lib";

interface ReportServiceTable {
  items;
  reportConfigData;
}

const ReportReturnLoyaltyServiceTable = ({
  items,
  reportConfigData,
}: ReportServiceTable) => {
  if (
    (Array.isArray(items) && items.length === 0) ||
    Object.keys(items).length === 0
  )
    return null;

  const { UniqueVinTableHeader, SalesTableHeader, PercentTableHeader } =
    getHeaders(reportConfigData);

  const UniqueVinTableContent = useMemo(() => {
    if (items.tableUnique) {
      return items.tableUnique.map((row) => {
        return rowHelper(row);
      });
    }

    return [];
  }, [items]);

  const SalesTableContent = useMemo(() => {
    if (items.tableLoyalty) {
      return items.tableLoyalty.map((row) => {
        return rowHelper(row);
      });
    }
  }, [items]);

  const tablePercent = useMemo(() => {
    if (UniqueVinTableContent && SalesTableContent) {
      // debugger
      return SalesTableContent.map((row) => {
        const inUniqueTable = UniqueVinTableContent.find(
          (el) => el[0] === row[0]
        );
        return row.map((cell, i) => {
          if (i === 0) {
            return cell;
          }
          if (inUniqueTable.length > 0) {
            if (cell === 0 || inUniqueTable[i] === 0) {
              return "0%";
            }
            return `${(100 / (cell / inUniqueTable[i])).toFixed(0)}%`;
          } else {
            return "0%";
          }
        });
      });
    }

    return [];
  }, [UniqueVinTableContent, SalesTableContent]);

  return (
    <>
      <Table
        {...UniqueVinTableHeader}
        customClassName={clsx(s.dealers_table, s.separator, {})}
        TableBodyComponent={ReportReturnLoyaltyServiceUniqueVINTable}
        items={UniqueVinTableContent}
        type={"srr"}
        sortable={false}
        positionStiki
        nameColumnChildren={nameColumnForUniqueVinTable}
      />
      <Table
        {...SalesTableHeader}
        customClassName={clsx(s.dealers_table, s.separator, {})}
        TableBodyComponent={ReportReturnLoyaltyServiceSalesTable}
        items={SalesTableContent}
        type={"srr"}
        sortable={false}
        positionStiki
        nameColumnChildren={nameColumnForSalesTable}
      />
      <Table
        {...PercentTableHeader}
        customClassName={clsx(s.dealers_table, {})}
        TableBodyComponent={ReportReturnLoyaltyServicePercentTable}
        items={tablePercent}
        type={"srr"}
        sortable={false}
        positionStiki
        nameColumnChildren={nameColumnForPercentTable}
      />
    </>
  );
};

export default ReportReturnLoyaltyServiceTable;
